import { render, staticRenderFns } from "./CustomerContacts.vue?vue&type=template&id=349b44d6&scoped=true&"
import script from "./CustomerContacts.vue?vue&type=script&lang=js&"
export * from "./CustomerContacts.vue?vue&type=script&lang=js&"
import style0 from "./CustomerContacts.vue?vue&type=style&index=0&id=349b44d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349b44d6",
  null
  
)

export default component.exports